import { SlackLogo as SlackMark } from './brand-logos'

type SlackLogoProps = {
  className?: string
}

/** Slack's vector mark at the larger default size older callers expect. */
export function SlackLogo({ className = 'h-10 w-10' }: SlackLogoProps) {
  return <SlackMark className={className} />
}
